import { Clock } from "lucide-react";
import { Card } from "../Card.js";

/** The design's three windows, kept as the shape a tariff schedule will take. */
const WINDOWS = [
  { window: "Off-peak", note: "When importing is cheapest" },
  { window: "Daytime", note: "When the house is carried by the grid or the bank" },
  { window: "Peak", note: "When importing costs most" },
] as const;

/**
 * The design's time-of-use dispatch schedule, built and empty.
 *
 * Two separate things are missing and they are missing for different reasons,
 * which is why this is one card and not two.
 *
 * The **tariffs** do not exist yet. There is no rate table in this system and
 * no currency amount anywhere that is not a placeholder, so the three windows
 * carry no prices. That is a later slice, and when it arrives it fills these
 * three cards in and changes nothing else.
 *
 * The **dispatch** will never exist. The design's schedule tells the inverter
 * what to do in each window -- pre-charge from the grid, soak from the array,
 * self-power at peak. `DECISIONS/0004` rules out writing to the inverter at
 * all: no mode switching, no charge-current changes, no register writes, and
 * the collector actively refuses a configure record travelling towards the
 * hardware. So these windows will describe when energy was cheap, never
 * command what the inverter does with it.
 */
export function DispatchCard() {
  return (
    <Card title="Time-of-use windows">
      <p className="mb-4 flex items-start gap-2 text-xs leading-relaxed text-ink-muted">
        <Clock size={16} aria-hidden="true" className="mt-0.5 shrink-0 text-accent-ink" />
        <span>
          No tariff table is configured, so these windows carry no prices yet. They will describe
          what energy cost. They will not tell the inverter what to do: this system does not write
          to the hardware.
        </span>
      </p>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {WINDOWS.map((entry) => (
          <div key={entry.window} className="rounded-2xl border border-line bg-line/30 p-4">
            <span className="mb-1 block text-xs text-ink-muted">Not set</span>
            <span className="block text-sm font-bold text-ink">{entry.window}</span>
            <span className="mt-1 block text-xs text-ink-muted">{entry.note}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}
